import { getStateColoursApi } from '../../api/state-colours-api';
import { getSseHub } from '../notifications/sse-hub';
import {
  STATE_COLOURS_TOPIC,
  setStateColourOverrides,
} from './state-colour-overrides-store';

/**
 * The transport half of the overrides store: the fetch and the SSE subscription. Split from
 * the store so the store (which the registry imports, and which therefore reaches Playwright
 * specs through the registry) stays pure data with no api-client or component import chain.
 * Screen code - agwa-state-badge, the settings page - imports THIS module.
 *
 * SSE topic "state-colours": a change made by any admin session reloads the map here. The
 * reload is a real request on purpose - the endpoint's URL is stable and ETag-cached, so
 * without a fetch nothing would ever notice the 304 turn into a 200.
 */

let started = false;

/** Force a refetch - the SSE handler's job, and recovery after a write conflict. */
export async function reloadStateColourOverrides(): Promise<void> {
  const result = await getStateColoursApi().getOverrides();
  if (result.success && result.data) {
    setStateColourOverrides(result.data.overrides);
  }
}

/**
 * Start the store once: first fetch plus the SSE subscription. Called by every badge and by
 * the settings page; only the first call does anything. Failures stay silent beyond the
 * console - a badge must render its code default, never blank, when the network is down.
 */
export function ensureStateColourOverridesLoaded(): void {
  if (started) return;
  started = true;

  void reloadStateColourOverrides().catch((error) => {
    console.error('[state-colours] initial override load failed', error);
  });

  try {
    getSseHub().subscribeTopic(STATE_COLOURS_TOPIC, () => {
      void reloadStateColourOverrides().catch((error) => {
        console.error('[state-colours] reload after SSE nudge failed', error);
      });
    });
  } catch (error) {
    // No hub (not signed in yet, or a test harness): the initial fetch still ran, and the
    // next full page load picks up any change.
    console.error('[state-colours] SSE subscription unavailable', error);
  }
}
